import React, {useEffect, useState} from 'react';
import {callApi, callEmptyParamsApi} from "../../../connection/ClientApi";
import Urls from "../../../connection/Urls";
import messages from "res/messages/farsi";
import {IsLP_MP_SP, IsLP_MP_SP_T} from "my-styles/media/media";
import {groupedList} from "components/utils/ListUtility";
import queryString from "query-string";
import EmptyBox from "components/emptyBox/EmptyBox";
import Pagination from "components/list/Pagination";
import {useHistory} from "react-router-dom";
import NotificationItem from "./NotificationItem";

import ICMessage from "res/images/messages.png";
import {Helmet} from "react-helmet";

export default function Notifications(props) {

    const history = useHistory()
    const urlParams = queryString.parse(props.location.search)

    const [isCancelled, setIsCancelled] = useState(false)
    const [notifications, setNotifications] = useState([])
    const [limit] = useState(IsLP_MP_SP_T() ? 6 : 15)
    const [pages, setPages] = useState([])
    const [showEmptyBox, setShowEmptyBox] = useState(false)

    function requestNotificationsCount() {
        callEmptyParamsApi(Urls.getNotificationsCount, (data) => {
            if (isCancelled) return

            if (parseInt(data.count) === 0) {
                setShowEmptyBox(true)
            } else {
                setShowEmptyBox(false)
                let number = data.count / limit
                if (data.count % limit > 0) {
                    number++
                }
                let tempPages = []
                for (let i = 1; i <= number; i++) {
                    tempPages.push({
                        number: i,
                        selected: i === parseInt(urlParams.p)
                    })
                }
                setPages(tempPages)
                requestNotifications()
            }
        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    function requestNotifications() {
        let params = new FormData()
        params.append("limit", limit)
        params.append("page", (urlParams && urlParams.p) ? urlParams.p : 1)
        callApi(Urls.getNotifications, params, (data) => {
            if (data.list) {
                let constLimit = 1
                let emptyCount = constLimit - (data.list.length % constLimit)
                let list = groupedList(data.list, constLimit, emptyCount)
                setNotifications(list)
            }
        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    function onNumberClick(number) {
        pushToHistory(urlParams.s, number)
    }

    function pushToHistory(s, p) {
        props.onNavigate(history, '/notifications?p=' + p)
    }

    function onBackClick() {
        pushToHistory(urlParams.s, (parseInt(urlParams.p) - 1))
    }

    function onNextClick() {
        pushToHistory(urlParams.s, (parseInt(urlParams.p) + 1))
    }

    useEffect(() => {
        requestNotificationsCount()

        return () => {
            setIsCancelled(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.location.search])

    return (
<>
    <Helmet>
        <title>صرفه مارکت - اعلانات</title>
        <meta name="description" content="لیست محصولات ما بر اسا دسته بندی انتخابی شما "/>
        <meta property="og:title" content="صرفه مارکت - دسته بندی محصولات"/>
        <meta property="og:description" content="لیست محصولات ما بر اسا دسته بندی انتخابی شما "/>
        <meta property="og:image" content="%PUBLIC_URL%/favicon.ico"/>
        <meta property="og:url" content="https://sarfemarket.ir/"/>
        <meta name="google-site-verification" content="a7UDcP_j_QBlp1S7KGeczLTlvDmYkzvwyBo7Qa-qbH0"/>
    </Helmet>
    <div className="hInLPT_vInFMS fullWidth">
        <div className="fullWidth hideInLPT_showInFMS center">
            <img className="twoFromThree" src={ICMessage} alt=""/>
        </div>
        <div className="wInLP55_wInT50_wInFMS100 marginTopBottomMedium">
            {showEmptyBox ?
                <div className="marginTopBottomMedium">
                    <EmptyBox message={messages.notificationListEmpty}/>
                </div> :
                <div>
                    <div
                        style={IsLP_MP_SP() ? {minHeight: "35em"} : {}}>
                        {notifications.map((notificationGroup, index) => {
                            return (<div key={index} className="horizontalFullScreen">
                                {notificationGroup.map((notification, index1) => {
                                    return <NotificationItem
                                        {...props}
                                        key={index1}
                                        notification={notification}
                                        onDeleteNotification={() => {
                                            requestNotifications()
                                        }}
                                    />
                                })}
                            </div>)
                        })}
                    </div>
                    {(notifications.length > 0 && notifications.length > 0) &&
                        <div style={{float: "left"}}>
                            <br/>
                            <Pagination
                                pages={pages}
                                onNumberClick={onNumberClick}
                                onNextClick={onNextClick}
                                onBackClick={onBackClick}/>
                        </div>
                    }
                </div>
            }
        </div>
        <div className="showInLPT_hideInFMS wInLP55_wInT50_wInFMS100 left">
            <img className="wInLP75_wInT85_wInFMS100" src={ICMessage} alt={"صرفه مارکت"}/>
        </div>
    </div>
</>
      )

}